var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "title is-3" }, [_vm._v("Summary Report")]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-4" }, [
        _vm._v(
          '\n    The current meeting will be automatically selected, but you can select\n    additional meetings to compare the numbers. Select or type into the drop\n    down and click the "Add" button and then click "Download Report" when\n    finished.\n  '
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-8 flex flex-col lg:flex-row w-full" },
        [
          _c("multiselect", {
            staticClass: "max-w-sm mb-4",
            attrs: {
              label: "name",
              "track-by": "id",
              options: _vm.meetingsList
            },
            model: {
              value: _vm.selectedValue,
              callback: function($$v) {
                _vm.selectedValue = $$v
              },
              expression: "selectedValue"
            }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "self-end lg:self-auto lg:ml-4 button",
              on: { click: _vm.add }
            },
            [_vm._m(0), _vm._v(" "), _c("span", [_vm._v("Add")])]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.selectedMeetings.length
        ? _c("h4", { staticClass: "title is-4" }, [
            _vm._v("\n    Comparison Metings\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.selectedMeetings, function(meeting, idx) {
        return _c("div", { key: idx, staticClass: "mt-2" }, [
          _c("span", { staticClass: "subtitle is-6" }, [
            _vm._v(_vm._s(meeting.name))
          ]),
          _vm._v(" "),
          _c("span", [
            _c(
              "a",
              {
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.remove(meeting.id)
                  }
                }
              },
              [_vm._v("(remove)")]
            )
          ])
        ])
      }),
      _vm._v(" "),
      _c(
        "form",
        {
          ref: "form",
          staticClass: "mt-16",
          attrs: { action: _vm.functionUrl, method: "POST" }
        },
        [
          _c("input", {
            attrs: { type: "hidden", name: "token" },
            domProps: { value: _vm.token }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "meetingIds" },
            domProps: { value: _vm.selectedMeetingIdFormData }
          }),
          _vm._v(" "),
          _c("input", {
            staticClass: "button is-success is-medium w-full lg:w-auto",
            attrs: {
              type: "submit",
              value: "Download Report",
              disabled: !_vm.token
            }
          })
        ]
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "fas fa-plus" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04ee52c5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04ee52c5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/meeting/SummaryReportBuilder.vue
// module id = null
// module chunks = 